import { SelectedAnalyticsComponent } from './containers/selected-analytics.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ComponentsModule } from './components/';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { reducers } from './reducers/index';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { AnalyticsViewPageComponent } from './containers/analytics-view-page.component';
import { FunnelEffects } from './effects/funnel';
import { ReferralsEffects } from './effects/referrals';
import { FunnelService } from './services/funnel';
import { ReferralsService } from './services/referrals';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: AnalyticsViewPageComponent,
        pathMatch: 'full',
      },
    ]),

    StoreModule.forFeature('analytics', reducers),

    EffectsModule.forFeature([FunnelEffects, ReferralsEffects]),
    FlexLayoutModule,
  ],
  exports: [AnalyticsViewPageComponent, SelectedAnalyticsComponent],
  declarations: [AnalyticsViewPageComponent, SelectedAnalyticsComponent],
  providers: [FunnelService, ReferralsService],
})
export class AnalyticsModule {}
